import React, {useEffect, useState} from "react";
import "./PackManAdd.scss";
import {PackManHederBack} from "../PackManHederBack/PackManHederBack";
import {AddCard} from "../AddCard/AddCard";
import {SearchCard} from "../SearchCard/SearchCard";
import {orderPickerOrderBulkAddProduct_api, StoreOnlineSearch} from "../PackManService";
import {useHistory, useLocation, useParams} from "react-router-dom";

function PackManAdd() {

    const {id} = useParams()
    const history = useHistory()

    const [addList,set_addList] = useState([])
    const [merchant, set_merchant] = useState(null)
    const [searchMode, set_searchMode] = useState(false)
    const [results, set_results] = useState([])
    const [search, set_search] = useState([])
    const [submitLadda, set_submitLadda] = useState(false)


    useEffect(()=>{
        console.log("OOOOOOOOOOO : ",id)
    },[])


    const doSearch = async (value) => {
        window.hh = 1;
        set_search(value)
        console.log("word : ", value);
        if (value.length > 2) {
            set_searchMode(true);
            try {
                let response = await StoreOnlineSearch( value, 1);
                console.log("Searched : ", response);
                set_results(response.data.results);
                const elm = document.getElementById("searchList");
                elm.scrollTo({left: 0, top: 0});
            } catch (e) {
                console.log(e);
            }
        }

        if (value.length < 1) {
            set_searchMode(false);
            set_results([])
        }
    }


    const selectItem = (item)=>{
        set_searchMode(false)
        set_results([])
        set_addList(list=>[...list,item])
    }

    const deleteFromList = (item)=>{
        if(item.quantity-1===0){
            set_addList(addList.filter(pro=>pro.uid!==item.uid))
            return;
        }
        set_addList(
            addList.map(pro =>
                pro.uid === item.uid ? {...pro, quantity : item.quantity-1} : pro
            ))
    }

    const addToList = (item)=>{
        set_addList(
            addList.map(pro =>
                pro.uid === item.uid ? {...pro, quantity : item.quantity+1} : pro
            ))
    }

    const submitAddOrder = async () =>{
        set_submitLadda(true)
        let obj = addList.map(item=>{
            return {
                product_id: item.uid,
                quantity: item.quantity
            }
        })

        console.log(addList)
        try{
            const response = await orderPickerOrderBulkAddProduct_api(id,obj)
            set_submitLadda(false)

            // if(!window.addProducts)
            //     window.addProducts=[]


            // let finalObj = []
            // addList.forEach(a=>{
            //     // let find = window.addProducts.find(f=>f.uid===a.uid)
            //     // if(!find)
            //     finalObj.push({...a,product:a,picked_quantity:0})
            // })

            // window.addProducts = finalObj
            history.goBack()
        }catch (e) {
            set_submitLadda(false)
            console.log(e)
        }
    }

    return (
        <div className="packMan-add-container">

            <PackManHederBack title="افزودن کالا"/>

            <div className="packMan-add-body">

                {/*factor row*/}
                <div className="add-factor-row">
                    <div className="add-factor-item">
                        <span>{id}</span>
                        <img src="/svg/clarity_details-line.svg" alt=""/>
                    </div>
                </div>


                <div className="add-search-row">
                    <input type="text" name="" id=""
                           value={search}
                           onChange={(e) => {
                               doSearch(e.target.value)
                           }}
                           placeholder="جستجوی سفارشات"/>
                    <img src="/svg/magni.svg" alt=""/>
                </div>

                {searchMode?<div className="packMan-searchList">
                    <div className="packMan-searchList-card">
                        {results.map(pro=>{
                            return(
                                <SearchCard item={pro} select={selectItem}/>
                            )
                        })}
                    </div>
                </div>:null}

                <div className="packMan-add-list">
                    {addList.map(item=>{
                        return(
                            <AddCard item={item} remove={deleteFromList} add={addToList}/>
                        )
                    })}
                </div>
            </div>


            <div className="packMan-add-footer">
                <div className="packMan-add-btn" onClick={()=>{
                    console.log("list ",addList)
                    submitAddOrder()

                }}>
                    <span>
                        {submitLadda?<i className="fa fa-spinner fa-spin"></i>:
                            <span>ثبت</span>
                        }
                    </span>
                </div>
            </div>

        </div>
    )
}

export {PackManAdd}
